import styled from 'styled-components';

const ConcurrentSessionModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  max-width: 600px;
  width: 90%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #FFFFFF;
  border-radius: 16px;
  padding: 20px;
  
  &:focus{
    outline: none;
  }
`;

export default ConcurrentSessionModalContainer;
